import dynamic from 'next/dynamic';

import AppLayout from '../layout/AppLayout';
import AppHead from '../components/AppHead';
import { useAppStateContext } from '../hooks/context';

const DynamicAppBirthday = dynamic(() => import('../components/AppBirthday/AppBirthday'));

export default function Birthday() {
  const { parameters } = useAppStateContext().context;

  const title = parameters?.data?.find((x) => x.keyword === 'birthday_page')?.value;
  const language_urls = [
    { lang: 'ge', url: 'birthday' },
    { lang: 'en', url: 'birthday' },
  ];

  return (
    <AppLayout localesUrls={language_urls}>
      <AppHead metaTitle={title} language_urls={language_urls} />
      <DynamicAppBirthday />
    </AppLayout>
  );
}
